import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { DmpLogo } from '../../brand/DmpLogo';
import { BdFlag } from '../../brand/BdFlag';
import type { MobileNav } from '../../../types/mobile';
export function SplashScreen({
  nav
}: {
  nav: MobileNav;
}) {
  const {
    reset
  } = nav;
  useEffect(() => {
    const t = window.setTimeout(() => reset('login'), 2600);
    return () => window.clearTimeout(t);
  }, [reset]);
  return <button onClick={() => nav.reset('login')} className="flex h-full w-full flex-col items-center bg-white px-8 text-center" aria-label="চালিয়ে যান" data-id="element-1195" data-mp="dmp4xghykc1u">
      <div className="flex w-full justify-end pt-3" data-id="element-1196" data-mp="mndb5p141846">
        <BdFlag width={26} data-id="element-1197" data-mp="mo54et78itra" />
      </div>
      <motion.div initial={{
      opacity: 0,
      y: 12
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.4
    }} className="flex flex-1 flex-col items-center justify-center" data-id="element-1198" data-mp="ho0rte9g6j6c">
        <DmpLogo size={120} data-id="element-1199" data-mp="1y3twu039ckzh" />
        <p className="mt-6 font-heading text-xl font-bold text-navy-800" data-id="element-1200" data-mp="1t3flo96d0ux8">ঢাকা মেট্রোপলিটন পুলিশ</p>
        <div className="my-4 h-0.5 w-12 bg-bdgreen-600" data-id="element-1201" data-mp="1z7uezy0z7vh8" />
        <p className="text-base font-medium text-slate-600" data-id="element-1202" data-mp="1z9du3lawc0hf">কিউআর ভিত্তিক</p>
        <p className="font-heading text-lg font-bold text-navy-900" data-id="element-1203" data-mp="237bjop8kwolc">সিএনজি ও চালক যাচাই ব্যবস্থা</p>
        <div className="mt-8 flex items-center gap-2 text-xs text-slate-400" data-id="element-1204" data-mp="288irgoaq1ns0">
          <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-navy-800" data-id="element-1205" data-mp="2d6168vbf6x7x" />
          লোড হচ্ছে…
        </div>
      </motion.div>
      <div className="w-full border-t border-border pb-8 pt-4" data-id="element-1206" data-mp="1fl51591j3qgv">
        <p className="text-sm font-semibold text-navy-800" data-id="element-1207" data-mp="1kjgcjo7h2917">ট্রাফিক বিভাগ</p>
        <p className="text-xs text-slate-500" data-id="element-1208" data-mp="1pgzrkqbzupu7">ঢাকা মেট্রোপলিটন পুলিশ</p>
        <p className="mt-2 font-mono text-[10px] text-slate-400" data-id="element-1209" data-mp="1pfom8m2wha0z">সংস্করণ ১.০.০ (Phase 1)</p>
      </div>
    </button>;
}